/* src/app/shared/components/actions/actions.component.css */
.drop-btn {
  cursor: pointer;
  padding: 7px;
  border-radius: 4px;
  margin-left: 0;
  border: 1px solid #cdc7c7;
  font-size: 1rem;
}
.fancy-button {
  display: flex;
  padding: 8px 12px;
  height: 2.571rem;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 2px solid #bbbbbb;
  background:
    linear-gradient(
      99deg,
      #DDD -11.82%,
      #D6D6D6 60.87%,
      #F0F0F0 119.15%);
  color: #3F3F3F;
  text-shadow: 0px 2px 4px #FFF;
  font-family: Outfit;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  transition: none;
}
.fancy-button:hover {
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  border: 2px solid #11B8AE;
  background:
    linear-gradient(
      99deg,
      #DDD -11.82%,
      #F2F2F2 60.87%,
      #F0F0F0 119.15%);
}
.fancy-button:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
  transition: none;
}
.error-message {
  font-size: 1.143rem;
}
.action-menu li:has(:focus-visible) {
  background-color: #f5f5f5;
  outline: var(--focus-outline);
}
#menuDropdown ::ng-deep .ant-menu-title-content {
  width: 100%;
  display: inline-block;
}
.action-btn {
  border: none;
  width: 100%;
  text-align: left;
  background-color: inherit;
}
.action-btn:focus-visible {
  outline: none;
}
:host ::ng-deep .action-menu .action-item.ant-menu-item-active,
:host ::ng-deep .action-menu .action-item[aria-selected=true],
:host ::ng-deep .action-menu .action-item:focus,
:host ::ng-deep .action-menu .action-item:focus-visible,
:host ::ng-deep .action-menu .action-item:focus-within,
.action-menu li.action-item:focus-within,
.action-menu li:has(:focus-visible) {
  background-color: #f5f5f5;
  outline: 3px solid #000 !important;
  outline-offset: 0 !important;
  border-radius: 4px;
  box-shadow: none !important;
}
:host ::ng-deep .action-menu .action-btn,
:host ::ng-deep .action-menu .action-btn:focus,
:host ::ng-deep .action-menu .action-btn:focus-visible {
  outline: 0 !important;
  box-shadow: none !important;
  border: 0;
}
:host ::ng-deep .action-menu .ant-menu-item-selected {
  background: inherit !important;
  outline: none !important;
}
/*# sourceMappingURL=actions.component-KNSALX5V.css.map */
